import {actions} from "./Reducer"
/**
 * Actions that fire saga watchers
 */

// singular 
export const createSupplierTagAction = (formData) => ({
  type : actions.CREATE_SUPPLIER_TAG,
  payload : formData
})


export const updateSupplierTagAction = (id , formData) => ({
  type : actions.UPDATE_SUPPLIER_TAG,
  payload : {
    id, 
    formData
  }
})

// Plural
export const getSupplierTagsAction = (body) => ({
  type: actions.GET_SUPPLIER_TAGS,
  payload : body
});

/**
 * Actions that are fired by redux-saga watchers
 */

// singular
export const createSupplierTagSuccessAction = tag => ({
  type : actions.CREATE_SUPPLIER_TAG_SUCCESS,
  payload : tag
})

export const updateSupplierTagSuccessAction = tag => ({
  type : actions.UPDATE_SUPPLIER_TAG_SUCCESS,
  payload : tag
})


// Plural
export const getSupplierTagsSuccessAction = SupplierTags => ({
  type: actions.GET_SUPPLIER_TAGS_SUCCESS,
  payload: SupplierTags
});


/**
 * Misc
*/
export const setSupplierTagsIsLoadingAction = isLoading => ({
  type: actions.SET_SUPPLIER_TAGS_IS_LOADING,
  payload: isLoading
});

export const setSupplierTagsCountAction = count => ({
  type: actions.SET_SUPPLIER_TAGS_COUNT,
  payload: count
});

export const setSearchValueAction = value => ({
  type : actions.SET_ST_SEARCH_VALUE,
  payload : value
})